'use client';

import { lazy } from 'react';

export const LazyNotFoundPage = lazy(() =>
  import('./NotFoundPage').then((module) => ({ default: module.NotFoundPage })),
);
